export const RESTRICTIVE_ELIGIBILITY_RULES = [
  'ustaYellowBall',
  'roundRobinYellowBall',
  'roundRobinGreenBall',
  'roundRobinOrangeBall',
  'minimumNtrp',
  'maximumNtrp',
  'playerSuspension',
];

export const ELIGIBILITY_RULES_DESCRIPTION = [
  { ruleId: 'age', long: 'Player does not meet the age eligibility for this event.', short: 'Age' },
  { ruleId: 'gender', long: 'Player does not meet the gender requirements for this event.', short: 'Gender' },
  { ruleId: 'playerSuspension', long: 'Player is suspended.', short: 'Suspension' },
  {
    ruleId: 'ustaMembership',
    long: 'An active USTA membership is required to enter this event.',
    short: 'USTA membership',
  },
  { ruleId: 'wheelchair', long: 'Only wheelchair players are eligible for this event.', short: 'Wheelchair event' },
  {
    ruleId: 'rating',
    long: 'NTRP rating must be equal or 0.5 point less than to the rating for the division.',
    short: 'NTRP rating',
  },
  {
    ruleId: 'WTNrating',
    long: 'Player does not meet the WTN rating requirements for this event.',
    short: 'WTN rating',
  },
  {
    ruleId: 'ustaResidency',
    long: 'This event is limited to residents of the USTA section and/or district.',
    short: 'USTA residency',
  },
  { ruleId: 'ntrpSelfRate', long: 'NTRP rating is required to enter this event.', short: 'NTRP required' },
  {
    ruleId: 'ustaRequiresProfile',
    long: 'Player must have a USTA account to register for this tournament.',
    short: 'USTA profile',
  },
  {
    ruleId: 'ustaYellowBall',
    long: 'Yellow ball competition level is required to enter this event.',
    short: 'Yellow ball',
  },
  {
    ruleId: 'roundRobinYellowBall',
    long: 'Yellow ball competition level is required to enter this event.',
    short: 'Yellow ball',
  },
  {
    ruleId: 'roundRobinGreenBall',
    long: 'Green Ball competition level is required to enter this event.',
    short: 'Green ball',
  },
  {
    ruleId: 'roundRobinOrangeBall',
    long: 'Orange Ball competition level is required to enter this event.',
    short: 'Orange ball',
  },
  { ruleId: 'invalidDateOfBirth', long: 'This player is missing a date of birth.', short: 'Missing DOB' },
  {
    ruleId: 'residencyDeclarationRequired',
    long: 'To register for this event the residency of the player must be declared in their settings and meet the specific requirement for this level.',
    short: 'Residency declaration required',
  },
  {
    ruleId: 'residencyClosedEvent',
    long: 'Player does not meet the residency requirements for this event.',
    short: 'Residency',
  },
  {
    ruleId: 'residencyOpenEvent',
    long: 'Player does not meet the residency requirements for this event.',
    short: 'Residency',
  },
  {
    ruleId: 'minimumNtrp',
    long: 'NTRP rating is below the minimum rating allowed.',
    short: 'NTRP rating below minimum',
  },
  {
    ruleId: 'maximumNtrp',
    long: 'NTRP rating is above the maximum rating allowed',
    short: 'NTRP rating above maximum',
  },
];
